







































































import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { CreateUserBindingModel } from '../store/types';
import axios from 'axios';
const namespace = 'profile';

@Component({
    name: 'RegisterUser',
    components: {},
})
export default class RegisterUser extends Vue {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('register', { namespace }) private register: any;

    private showPassword = false;
    private firstName = '';
    private lastName = '';
    private email = '';
    private password = '';
    private confirmPassword = '';
    private errors: string[] = [];

    private rules = {
        name: [
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (v: any) => !!v || 'Name is required',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (v: any) => v.length <= 10 || 'Name must be less than 10 characters',
        ],
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        email: [(v: any) => !!v || 'E-mail is required', (v: any) => /.+@.+/.test(v) || 'E-mail must be valid'],
    };

    private registerUser() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        axios.interceptors.response.use(
            response => response,
            error => {
                self.errors = Object.keys(error.response.data.ModelState).map(
                    k => error.response.data.ModelState[k][0],
                );
                return Promise.reject(error);
            },
        );
        const model: CreateUserBindingModel = {
            FirstName: this.firstName,
            LastName: this.lastName,
            Email: this.email,
            Password: this.password,
            ConfirmPassword: this.confirmPassword,
            Username: this.email,
        };
        this.register(model)
            .then(() => {
                this.$router.push({ name: 'home' });
            })
            .catch((err: unknown) => {
                console.error(err);
            });
    }
}
